export default "__VITE_ASSET__DgWdJ7vx__"